import React, { PureComponent as Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';
import FilterForm from './FilterForm';

class Filters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      keyword: props.keyword,
      is_parent: props.is_parent,
      per_page: props.per_page,
      sort_by: props.sort_by,
    }
    this._handleApplyFilterButtonClick = this._handleApplyFilterButtonClick.bind(this);
    this._handleOnChangeInputAndApply = this._handleOnChangeInputAndApply.bind(this);
    this._handleCategoryChangeInput = this._handleCategoryChangeInput.bind(this);
  }

  _handleCategoryChangeInput(e) {
    const lastState = {...this.state};
    lastState['is_parent'] = e.target.value
    this.setState({...lastState});
  }

  _handleOnChangeInputAndApply(e){
    const lastState = {...this.state};
    lastState[e.target.name] = e.target.value;
    this.setState({...lastState}, ()=> this._handleSubmitFilter());
  }

  _handleApplyFilterButtonClick(e){
    e.preventDefault();
    this._handleSubmitFilter();
  }

  _handleSubmitFilter(){
    const {
      keyword,
      is_parent,
      per_page,
      sort_by
    } = this.state;
    this.props.onApplyFilter({
      keyword,
      is_parent,
      per_page,
      sort_by
    });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.isReset && this.props.isReset!==nextProps.isReset){
      const {
        keyword,
        is_parent,
        per_page,
        sort_by
      } = nextProps;
      this.setState({
        keyword,
        is_parent,
        per_page,
        sort_by
      })
    }
  }

  render(){
    return(
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword = {this.props.keyword}
            onInputChange = {this.props.onHandleChange}
            onSubmit = {this.props.onHandleSearch}
          />
          <FilterForm
            is_parent={this.state.is_parent}
            onCategoryInputChange = {this._handleCategoryChangeInput}
            isCheckedCategory = {this._isCheckedCategory}
            onSubmit={this._handleApplyFilterButtonClick}
          />
          <hr/>
          <SortForm
            per_page={this.props.per_page}
            sort_by={this.props.sort_by}
            onInputChange={this.props.onHandleChangeAndSubmit}
          />
        </CardBody>
      </Collapse>
    )
  }
}

export default Filters

Filters.propTypes= {
  keyword: propTypes.string,
  is_parent: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  onHandleChange: propTypes.func,
  onHandleSearch: propTypes.func,
  onHandleChangeAndSubmit: propTypes.func,
  onApplyFilter: propTypes.func
}

Filters.defaultProps= {
  keyword: '',
  is_parent: '',
  per_page: 15,
  sort_by: ''
}